import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SuggestionService {

  SUGGESTIONS_COTTAGE_URL = environment.apiBaseUrl + '/realty/cottage-suggest/';
  constructor(private http: HttpClient) {
  }

  getSuggestions(query: string) {
    return this.http.get(this.SUGGESTIONS_COTTAGE_URL + query);
  }
}
